module.exports = __webpack_public_path__ + "img/title_picture.5b9bfbae.png";